// Single source of truth: every tenant amount is displayed in the ORGANIZATION currency,
// chosen once at tenant creation. Payment methods (USDT TRC20 etc.) are transfer rails only.
let _displayCur = "USD";
export const setDisplayCurrency = (c) => { _displayCur = c || "USD"; };
export const getDisplayCurrency = () => _displayCur;

const CUR_SYMBOL = {
  USD: "$", EUR: "€", GBP: "£", UAH: "₴", PLN: "zł", CZK: "Kč", RON: "lei", KZT: "₸",
  TRY: "₺", AED: "AED ", BRL: "R$", INR: "₹", CAD: "C$", AUD: "A$", JPY: "¥", CHF: "CHF ",
  SEK: "kr ", NOK: "kr ", DKK: "kr ", MXN: "MX$", USDT: "₮",
};

export const fmtMoney = (v, currency) => {
  const n = Number(v || 0);
  const cur = currency || _displayCur;
  const sym = CUR_SYMBOL[cur] ?? `${cur} `;
  return `${sym}${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const fmtNumber = (v) => Number(v || 0).toLocaleString("en-US");

// Display timezone resolution: personal override -> device/browser timezone -> Europe/Kyiv.
export const browserTimezone = () => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch { return ""; }
};
let _displayTz = browserTimezone() || "Europe/Kyiv";
export const setDisplayTimezone = (tz) => { _displayTz = tz || browserTimezone() || "Europe/Kyiv"; };
export const getDisplayTimezone = () => _displayTz;

// YYYY-MM-DD of a Date in the current display timezone (for date-range defaults).
export const isoDayInTz = (d) => {
  try { return d.toLocaleDateString("en-CA", { timeZone: _displayTz }); }
  catch { return d.toISOString().slice(0, 10); }
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  const opts = { month: "short", day: "numeric", year: "numeric" };
  try {
    return d.toLocaleDateString("en-US", { ...opts, timeZone: _displayTz });
  } catch {
    return d.toLocaleDateString("en-US", opts);
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  const opts = { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", hourCycle: "h23" };
  try {
    return d.toLocaleString("en-US", { ...opts, timeZone: _displayTz });
  } catch {
    return d.toLocaleString("en-US", opts);
  }
};

export const shortId = (id) => (id ? String(id).slice(0, 8) : "—");

// Tenant-scoped public id shown in UI (#1, #2 ...) — never the global db id.
export const pubId = (row) => (row && row.tenant_seq != null ? `#${row.tenant_seq}` : "—");

// Strip the legacy display-only "[GEO]" placeholder from an offer name (display only).
export const cleanOfferName = (name) => String(name || "").replace(/\[GEO\]/g, " ").replace(/\s+/g, " ").trim();

export const initials = (name = "") =>
  name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();


import { COUNTRY_NAMES } from "@/lib/countries";

// Country flag emoji from a 2-letter GEO code (UK normalised to GB).
export const flagEmoji = (code) => {
  if (!code) return "🌐";
  let c = String(code).trim().toUpperCase();
  if (c === "UK") c = "GB";
  if (c === "WW") return "🌐";
  if (!/^[A-Z]{2}$/.test(c)) return "🌐";
  return String.fromCodePoint(...[...c].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65));
};

export const geoName = (code) => COUNTRY_NAMES[String(code || "").toUpperCase()] || code || "—";

